import { Box } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

export const NotFound: FC = () => {
  return (
    <Box>
      <h2>Page not found</h2>
      <Link to="/">Go to the main page</Link>
    </Box>
  );
};
